import React from 'react'
import {Row, Col, Tooltip} from 'antd'
import {
    SelectorField,
    DatePickerField,
    DurationPickerField, TimePickerFieldWithTooltip,
} from './FormFields/FormInputs'
import { Location } from '../../pages/FlightForm/FlightForm'
import {QuestionCircleTwoTone} from "@ant-design/icons";

const FormInbound: React.FC<{
  disabled: boolean
  handleChange: () => void
  airports: Location[]
  destinationLocations: Location[]
  loading: boolean
}> = ({ disabled, handleChange, airports, destinationLocations, loading }) => {
  const tooltip = disabled ?
      "Form filled with outbound location's time zone time. This is Lithuanian time zone translated time" :
      "Outbound location's time (Outbound Location's time zone time, not Lithuanian UTC+3/UTC+2)";
    return (
    <>
      <label className='form-type-label'>INBOUND</label>

      <Row gutter={16}>
        <Col>
          <DatePickerField
            disabled={disabled}
            name='inFlightStartDate'
            label='Flight start date'
            handleChange={handleChange}
            testId='inFlightStartDate'
            loading={loading}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <SelectorField
            disabled={disabled}
            name='inLocationId'
            label='Travel start city'
            handleChange={handleChange}
            selectorData={destinationLocations}
            loading={loading}
          />
        </Col>
        <Col>
          <TimePickerFieldWithTooltip
            disabled={disabled}
            name='inFlightStartTime'
            label={
              <Tooltip overlay={tooltip}>
          <span>
            Flight start time <QuestionCircleTwoTone />
          </span>
            </Tooltip>
          }
            testId='inFlightStartTime'
            handleChange={handleChange}
            loading={loading}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <SelectorField
            disabled={disabled}
            name='inAirportId'
            label='Arrival Airport'
            handleChange={handleChange}
            selectorData={airports}
            loading={loading}
          />
        </Col>
        <Col>
          <DurationPickerField
            disabled={disabled}
            name='inDurationOfFlight'
            label='Flight duration'
            testId='inDurationOfFlight'
            handleChange={handleChange}
            loading={loading}
          />
        </Col>
      </Row>
    </>
  )
}
export default FormInbound
